// Contact links and nav sections shared across the site
export const UPWORK = "https://www.upwork.com/freelancers/~01ba6fdd8b0d35e17e?mp_source=share";
export const WHATSAPP =
  "https://wa.me/923070145744?text=Hi%20Sami%2C%20I%20found%20your%20portfolio%20and%20want%20to%20discuss%20a%20project.";
export const GITHUB = "https://github.com/ranasami006";

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "work", label: "Work" },
  { id: "career", label: "Career" },
  { id: "contact", label: "Contact" },
];
